import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './AddUserForm.module.css'; 

const AddUserForm = () => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone_area_code: '',
    phone_number: '',
    membership_type: 'Non Paid', 
    account_creation_date: new Date().toISOString().split('T')[0], 
    start_subscription_date: '',
    last_payment_date: '',
    next_renewal_date: '',
    last_login: '',
    addon_subscription: ''
  });
  const [error, setError] = useState(''); 
  const navigate = useNavigate();

  const API_BASE = "https://xenorize.com/api";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); 

    if (!user.name || !user.email || !user.phone_number) {
      setError('Name, email, and phone number are required');
      return;
    }

    try {
      await axios.post(`${API_BASE}/users`, user);
      navigate('/admin-panel'); 
    } catch (error) {
      console.error('Error adding user:', error);
      setError('Failed to add user. Please try again.');
    }
  };

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  return (
    <div className={styles.formContainer}>
      <h1>Add User</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={user.name}
          onChange={handleChange}
          placeholder="Enter Name"
        />
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={user.email}
          onChange={handleChange}
          placeholder="Enter Email"
        />        
        <label htmlFor="phone_area_code">Phone Area Code:</label>
        <input
          type="text"
          id="phone_area_code"
          name="phone_area_code"
          value={user.phone_area_code}
          onChange={handleChange}
          placeholder="Enter Phone Area Code"
        />        
        <label htmlFor="phone_number">Phone Number:</label>
        <input
          type="text"
          id="phone_number"
          name="phone_number"
          value={user.phone_number}
          onChange={handleChange}
          placeholder="Enter Phone Number"
        />        
        <label htmlFor="membership_type">Membership Type:</label>
        <br></br>
        <select
          name="membership_type"
          id="membership_type"
          value={user.membership_type}
          onChange={handleChange}
        >
          <option value="Non Paid">Non Paid</option>
          <option value="Paid - Essential">Paid - Essential</option>
          <option value="Paid - Plus">Paid - Plus</option>
          <option value="Paid - Premium">Paid - Premium</option>
        </select>
        <br></br>        
        <label htmlFor="addon_subscription">Addon Subscription:</label>
        <br></br>
        <textarea
          id="addon_subscription"
          name="addon_subscription"
          value={user.addon_subscription}
          onChange={handleChange}
          placeholder="Enter Addon Subscription Details"
        />        
        {error && <p className={styles.errorMessage}>{error}</p>} {}
        <br></br>
        <button type="submit">Add User</button>
      </form>
    </div>
  );
};

export default AddUserForm;
